import { useRef } from 'react';
import styled from 'foundations-theming/utils';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/components/View';
import { PriceWrapper } from './PriceWrapper';
import { PurchaseMotionWrapper } from './PurchaseMotionWrapper';
import { useIntersectionObserver } from '../../useIntersectionObserver';
import { useFeatureTableSessionCache } from '../FeatureTableSessionCacheProvider';
import { useFeatureMonetizationTracker } from '../../FeatureMonetizationTrackerProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StickyHeader = styled.th.withConfig({
  displayName: "CategoryHeader__StickyHeader"
})(["position:sticky;top:0;background-color:", ";z-index:1;"], ({
  theme
}) => theme.color['fill-surface-default']);

// Set opacity to 0 to make purchase motions and prices accessible to screen readers
const AccessibleHiddenSpan = styled.span.withConfig({
  displayName: "CategoryHeader__AccessibleHiddenSpan"
})(["opacity:", ";"], ({
  isHidden
}) => isHidden ? 0 : 1);
export const CategoryHeader = ({
  focusedCategory,
  title,
  tableHeaderConfig
}) => {
  const {
    skuCategoryName
  } = useFeatureTableSessionCache();
  const CategoryHeaderRef = useRef(null);
  const tracker = useFeatureMonetizationTracker();
  useIntersectionObserver({
    onIntersect: () => {
      tracker.track({
        action: 'on-category-header-scrolled-in-view',
        object: 'feature-table',
        featureCategoryName: title,
        skuCategoryName
      });
    },
    targetRef: CategoryHeaderRef
  });
  return /*#__PURE__*/_jsx(View, {
    as: "thead",
    children: /*#__PURE__*/_jsxs(View, {
      as: "tr",
      ref: CategoryHeaderRef,
      children: [/*#__PURE__*/_jsx(StickyHeader, {
        "aria-label": "feature",
        children: /*#__PURE__*/_jsx(TFlex, {
          align: "end",
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-600",
            textAlign: "left",
            marginBlockStart: "1000",
            "aria-label": I18n.text('feature-monetization.featureTable.categorizedFeatures.featureHeaderAriaLabel', {
              categoryName: title
            }),
            children: title
          })
        })
      }), tableHeaderConfig.map(columnConfig => /*#__PURE__*/_jsx(StickyHeader, {
        children: /*#__PURE__*/_jsxs(AccessibleHiddenSpan, {
          as: "span",
          isHidden: focusedCategory !== title && focusedCategory !== null,
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "heading-50",
            marginBlockStart: "800",
            paddingBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `feature-monetization.products.${columnConfig.productApiName}`
            })
          }), /*#__PURE__*/_jsx(PriceWrapper, {
            columnConfig: columnConfig
          }), /*#__PURE__*/_jsx(PurchaseMotionWrapper, {
            productApiName: columnConfig.productApiName,
            purchaseMotion: columnConfig.purchaseMotion
          })]
        })
      }, columnConfig.productApiName))]
    })
  });
};